import { faArrowRight, faThumbsUp, faTimes } from '@fortawesome/pro-solid-svg-icons';
import { ActionButton, CheckboxList, HeadingItem, RadioButtonList } from 'components';
import { ConfirmationPopup } from 'components/pop-up';
import { TripContext } from 'contexts';
import notify from 'devextreme/ui/notify';
import React, { FC, Fragment, useContext, useEffect, useState } from 'react';
import { useNavigation, useOrderItemService, useParamService } from 'services';
import { Temperature } from 'services/enums';
import { VerifyMultipleItemsReason } from 'services/types';
import { CheckBoxItem } from 'types';
import './mass-verify.scss';

export const MassVerifyPage: FC = () => {

    const [isConfirming, setIsConfirming] = useState<boolean>(false)
    const [selectedReason, setSelectedReason] = useState<VerifyMultipleItemsReason>({} as VerifyMultipleItemsReason)
    const [selectedTemperatures, setSelectedTemperatures] = useState<CheckBoxItem[]>([])
    const [otherValue, setOtherValue] = useState<string>('')

    const { getIntValue } = useParamService
    const { verifyItemsByTemps } = useOrderItemService()
    const { navigateBack } = useNavigation()
    let stopId = getIntValue('stopId')

    const tripContext = useContext(TripContext)
    const reasons: VerifyMultipleItemsReason[] = tripContext.verifyMultipleItemsReasons.toArray() ?? []
    const defaultTemperatures = (): CheckBoxItem[] => [
        { id: Temperature.Dry, isSelected: false, text: 'Dry', isEnable: true },
        { id: Temperature.Frozen, isSelected: false, text: 'Frozen', isEnable: true },
        { id: Temperature.Refrigerated, isSelected: false, text: 'Ref', isEnable: true }
    ]

    useEffect(() => {
        setSelectedTemperatures(defaultTemperatures())
        setSelectedReason({} as VerifyMultipleItemsReason)
        setOtherValue('')
    }, [])

    const isValidItemSelection = (): boolean => {
        return selectedTemperatures.filter(item => item.isSelected).length > 0;
    }

    const isValidSelection = (): boolean => isValidItemSelection() && selectedReason.id != null

    const handleSelectedTempsChanged = (selectedTemp: string | number, isSelected: boolean) => {
        let tempIndex = selectedTemperatures.findIndex(temp => temp.id === selectedTemp)
        selectedTemperatures[tempIndex].isSelected = isSelected
        setSelectedTemperatures([...selectedTemperatures])
    }

    const handleConfirmVerification = (): void => {
        if (selectedReason && stopId) {
            const verifiedItemCount: number = verifyItemsByTemps(stopId, selectedTemperatures.filter(temp => temp.isSelected).map<Temperature>(temp => temp.id as Temperature), selectedReason, otherValue);
            setIsConfirming(false)
            notify(`${verifiedItemCount} ${verifiedItemCount === 1 ? 'item has' : 'items have'} been verified!`, 'success', 3000)
            navigateBack()
        }
    }

    return (
        <Fragment>
            <Fragment>
                <Fragment>
                    <div className={'mass-verify-content'}>
                        <Fragment>
                            <div className={'card-material'}>
                                <HeadingItem text="Select Temperatures" />
                                <div className={'temp-selection-card'}>
                                    <CheckboxList data={selectedTemperatures} onValueChanged={handleSelectedTempsChanged} />
                                </div>
                            </div>
                            {isValidItemSelection() &&
                                <div className={'card-material'}>
                                    <HeadingItem text={'Select Reason'} />
                                    <div className={'mass-radio-list'}>
                                        <RadioButtonList<VerifyMultipleItemsReason>
                                            data={reasons}
                                            displayExpr={'description'}
                                            valueExpr={'id'}
                                            otherKeyValue={99}
                                            selectedItem={selectedReason}
                                            otherValue={otherValue}
                                            onOtherValueChanged={value => setOtherValue(value)}
                                            handleRadioChecked={reasonId => setSelectedReason(reasons.find(reason => reason.id === reasonId) ?? {} as VerifyMultipleItemsReason)}
                                        />
                                    </div>
                                </div>
                            }
                        </Fragment>
                    </div>
                </Fragment>
                <div className={'bottom-fix-action-row'}>
                    <ActionButton
                        enabled={isValidSelection()}
                        icon={faArrowRight}
                        buttonColor={'#76AB21'}
                        onClick={() => setIsConfirming(true)}
                        buttonText={'Confirm'}
                    />
                </div>
            </Fragment>
            <ConfirmationPopup
                isVisible={isConfirming}
                title="Confirm Verification"
                message={`Are you sure you want to verify these temperatures?`}
                button1={{ icon: faTimes }}
                button2={{ icon: faThumbsUp }}
                onClickButton1={() => setIsConfirming(false)}
                onClickButton2={handleConfirmVerification}
            />
        </Fragment>
    )
}
